<template>
    <!-- История оплаты -->
    <vs-popup class="pay_history_popup" title="Статусы платежей" :active.sync="payHistoryPopup">

        <div class="mb-2 flex items-center" v-if="payHistoryList.length && payHistoryList[0].contract.contract_number">
            {{$t('contract')}}: <vs-chip class="ml-2" color="primary">№{{payHistoryList[0].contract.contract_number}}</vs-chip>
        </div>

        <div id="data-list-list-view" class="data-list-container">
            <vs-table
                :noDataText="$t('no_data_text')"
                ref="table"
                class="contract_popup_table"
                :data="payHistoryList"
            >
                <template slot="thead">
                    <vs-th>№</vs-th>
                    <vs-th>{{$t('payment_date')}}</vs-th>
                    <vs-th>{{$t('amount')}}</vs-th>
                    <vs-th>{{$t('operation_number')}}</vs-th>
                    <vs-th>{{$t('status')}}</vs-th>
                    <vs-th></vs-th>
                </template>

                <template slot-scope="{data}">
                    <tbody>
                        <vs-tr
                            :data="tr"
                            :key="indextr"
                            v-for="(tr, indextr) in data"
                        >
                            <vs-td>
                                {{indextr+1}}
                            </vs-td>

                            <vs-td>
                                {{date(tr.death_date)}}
                            </vs-td>

                            <vs-td>
                                <span v-html="priceReplace(tr.amount)"></span>
                            </vs-td>

                            <vs-td>
                                {{tr.operation_id}}
                            </vs-td>

                            <vs-td>
                                <vs-chip
                                    v-if="tr.payment_status && tr.payment_status.name"
                                    :color="statusColor(tr.payment_status.name)">
                                        {{tr.payment_status.name}}
                                </vs-chip>
                                <span v-else>-</span>
                            </vs-td>

                            <vs-td>
                                <template v-if="tr.payment_status && tr.payment_status.name">
                                    <div v-if="checkButton(tr.payment_status.name)">
                                        <vs-button
                                            :href="tr.operation_url"
                                            color="primary"
                                            size="small"
                                            icon-pack="feather"
                                            icon="icon-credit-card"
                                            type="border">
                                                {{$t('pay')}}
                                        </vs-button>
                                    </div>
                                </template>
                            </vs-td>

                        </vs-tr>
                    </tbody>
                </template>

            </vs-table>
        </div>

        <!-- handler для инфинити скролла -->
        <infinite-loading class="vx-col w-full" ref="infiniteHistory" v-bind:distance="400" @infinite="infiniteHandler">
            <!-- показываем свой лоадер -->
            <div slot="spinner"></div>
            <!-- Если данных больше нет показываем сообщение -->
            <div slot="no-more"></div>
            <div slot="no-results">
                <div class="con-vs-alert con-vs-alert-primary">
                    <div class="vs-alert">{{$t('no_data_text')}}</div>
                </div>
            </div>
        </infinite-loading>

        <div id="history_loader" class="vs-con-loading__container"></div>
    </vs-popup>
</template>

<script>
import { price } from '../config'

export default {
    data() {
        return {
            page: 1,
            infiniteStatus: true,
            loading: false,
        }
    },
    watch: {
        payHistoryPopup(val) {
            // При открытии окна обнуляем данные таблицы
            if(val) {
                this.infiniteStatus = true
                this.page = 1
                this.$refs['infiniteHistory'].status = 0
            }
        }
    },
    methods: {
        checkButton(status) {
            // Показываем кнопку для повторной оплаты
            switch(status) {
            case 'сторнирована':
                return true
                break;
            case 'сторнирующая':
                return true
                break;
            default:
                return false
                break;
            }
        },
        statusColor(status) {
            // Меняем цвет статуса в зависимости от типа
            switch(status) {
            case 'новая':
                return 'dark'
                break;
            case 'на рассмотрении':
                return 'primary'
                break;
            case 'отклонена':
                return 'danger'
                break;
            case 'проведена':
                return 'success'
                break;
            case 'сторнирована':
                return 'warning'
                break;
            case 'сторнирующая':
                return 'warning'
                break;
            default:
                return 'primary'
                break;
            }
        },
        date(date) {
            // Перезаписываем дату
            return this.$moment(date).format('LL')
        },
        priceReplace(sum, color = '') {
            // Перезаписываем цену
            return price(sum, color)
        },
        async infiniteHandler($state) {
            // Если количество полученных элементов больше или равно общего количества, останавливаем инфинити скроллинг
            if(this.payHistoryList.length >= this.payHistoryCount)
                this.infiniteStatus = false

            // Если инфинити скроллинг активный запрашиваем данные для указанной страницы
            if(this.infiniteStatus) {
                try {
                    this.$nextTick(() => {
                        this.$vs.loading({
                            background: 'transparent',
                            container: '#history_loader',
                            scale: 0.6
                        })
                    })

                    this.page = this.page+1
                    const res = await this.$store.dispatch('finance/getPayHistory', {contract_uid: this.payUid, page: this.page})
                    await this.$store.dispatch('finance/getHistoryList', {uid: this.contract.uid, page: this.page})

                    $state.loaded()
                } catch(e) {
                    this.$vs.notify({
                        text: this.$t('error'),
                        color: 'danger'
                    })
                } finally {
                    this.$vs.loading.close('#history_loader > .con-vs-loading')
                }
            }
        }
    },
    computed: {
        payHistoryList() {
            return this.$store.state.finance.payHistoryList
        },
        payHistoryCount() {
            return this.$store.state.finance.payHistoryCount
        },
        payUid() {
            return this.$store.state.finance.payContractUid
        },
        payHistoryPopup: {
            get () {
                return this.$store.state.finance.payHistoryPopup
            },
            set (val) {
                this.$store.commit('finance/SET_PAY_HISTORY_POPUP', val)
            }
        }
    }
}
</script>

<style lang="scss">
.pay_history_popup{
    .vs-popup{
        width: 920px;
    }
}
</style>
